module.exports = __webpack_public_path__ + "static/media/white-logo-porter.bbd81b72.svg";